import AppliedFilterChip from "@/components/Filter/AppliedFilterChip";
import { defaultNS, useTranslation } from "@/lib/i18n";

import FilterTrans from "@/components/Filter/FilterTrans";
import { isUndefined } from "@/utils/typeGuards";
import { useDeviceGenre } from "../../genre/useDeviceGenre";
import type { DeviceGenreFilterChipProps } from "./types";

export default function DeviceGenreAppliedFilterChip({
  value,
  onChange,
}: DeviceGenreFilterChipProps) {
  if (isUndefined(value)) throw new Error("value must be defined");

  const { t: tHead } = useTranslation(defaultNS, {
    keyPrefix: "component.dataTable.headers",
  });

  const { i18n } = useDeviceGenre();

  return (
    <AppliedFilterChip
      iconName="DevicesIcon"
      onClear={() => onChange(undefined)}
    >
      <FilterTrans
        sub={tHead("deviceType")}
        type="contains"
        obj={value.map((v) => i18n(v)).join(", ")}
      />
    </AppliedFilterChip>
  );
}
